import React, { Component } from 'react'
import {
	Show,
	TabbedShowLayout,
	Tab,
	TextField,
	DateInput,
	ListButton,
	RefreshButton
} from 'admin-on-rest'
import {
	ReferenceField,
} from 'admin-on-rest/lib/mui';
import FlatButton from 'material-ui/FlatButton'
import ActionList from 'material-ui/svg-icons/action/list'
import { CardActions } from 'material-ui/Card'
import { formatDate, dateString } from '../util'
import { history } from '../App'

const AccountTitle = ({ record }) => (
	<span>
		Account
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		ID {record.id}
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		CS# {record.fields.cs_num}
	</span>
)

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const Actions = ({ basePath, record, data, hasDelete, hasShow, hasList }) => (
    <CardActions style={cardActionStyle}>
		<FlatButton
	        primary
	        label="List"
	        icon={<ActionList />}
	        style={{ overflow: 'inherit' }}
			onClick={ e => history.goBack() }
	    />
        <RefreshButton />
    </CardActions>
)

const AccountShow = props => (
	<Show title={<AccountTitle />} {...props} actions={<Actions/>}>
		<TabbedShowLayout value="1" submitOnEnter={false}>
			<Tab label="Details">
				<ReferenceField label="Dealership" source="fields.dealership" reference="dealerships" allowEmpty validation={{ required: true }} linkType={false}>
					<TextField source="name"/>
				</ReferenceField>
				<TextField label="First Name" source="fields.first_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Last Name" source="fields.last_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Middle Name" source="fields.middle_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Company Name" source="fields.company_name" />
				<TextField label="Sales Consultant" source="fields.sales_consultant" />
				<TextField label="OR/CR Submission Date" source="fields.or__cr_submission_date" parse={dateString}/>
				<TextField label="Model" source="fields.model" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Engine Number" source="fields.engine_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Chasis / Frame Number" source="fields.chasis_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
			</Tab>
			<Tab label="Payment">
				<ReferenceField label="Bank" source="fields.bank" reference="banks" allowEmpty validation={{ required: true }} style={{ display: 'inline-block' }} linkType={false}>
					<TextField source="name"/>
				</ReferenceField>
				<ReferenceField label="Payment Mode" source="fields.payment_mode" reference="bank_payment_modes" allowEmpty validation={{ required: true }} style={{ display: 'inline-block', marginLeft: 32 }} linkType={false}>
					<TextField source="name"/>
				</ReferenceField>
				<br style={{ height: 0 }}/>
				<TextField label="Invoice Date" source="fields.invoice_date" options={{ formatDate }} style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Invoice Number" source="fields.invoice_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Invoice Amount (₱)" source="fields.invoice_amount" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Financing Rate (%)" source="fields.financing_rate" />
				<TextField label="Term" source="fields.term" />
				<TextField label="Proceeds Amount (₱)" source="fields.proceeds" />
				<TextField label="Proceeds Collected (₱)" source="fields.proceeds_collected" />
				<TextField label="DI Percentage (%)" source="fields.di" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="DI Amount (₱)" source="fields.di_amount" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Chattel Mortgage Fee (₱)" source="fields.chattel_mortgage_fee" />
				<TextField label="Bank Contact Person" source="fields.bank_contact_person" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
				<TextField label="Bank Contact Number" source="fields.bank_contact_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
			</Tab>
		</TabbedShowLayout>
    </Show>
)

export default AccountShow



// WEBPACK FOOTER //
// ./src/Account/AccountShow.js